(function () {
  if (window.__providerCard) return;
  window.__providerCard = true;

  // The code currently on the cart, as far as this card knows. Seeded here
  // rather than on DOMContentLoaded so it is already set if auto-assign reports
  // back first; kept in step afterwards by render().
  var seed = document.querySelector('[data-provider-pdp]');
  var currentCode = (seed && seed.dataset.code) || null;

  var PROVIDER_API = 'https://admin-aizm.onrender.com/';
  var LOCATION_KEY = 'epicutis:auto-assign:location';
  var KM_PER_MILE = 1.609344;

  function roots() {
    return document.querySelectorAll('[data-provider-pdp]');
  }

  function customerPoint() {
    try {
      var raw = window.sessionStorage.getItem(LOCATION_KEY);
      var parsed = raw && JSON.parse(raw);
      return (parsed && parsed.point) || null;
    } catch (error) {
      return null;
    }
  }

  function milesBetween(lng1, lat1, lng2, lat2) {
    var R = 3958.7613;
    var toRad = function (d) { return (d * Math.PI) / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.pow(Math.sin(dLat / 2), 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.pow(Math.sin(dLng / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  // The measurement stays in miles so it matches the picker; AU and NZ change
  // only the wording. isMetricMarket comes from provider-locator-map.js,
  // loaded ahead of this file.
  function distanceAway(miles) {
    if (typeof isMetricMarket === 'function' && isMetricMarket()) {
      var km = miles * KM_PER_MILE;
      return km < 1 ? 'less than a kilometre away' : Math.round(km) + ' km away';
    }
    return miles < 1 ? 'less than a mile away' : Math.round(miles) + ' miles away';
  }

  // "Washington, DC · 2 miles away" - each half is dropped when unknown
  // rather than guessed at.
  function metaLine(provider) {
    var parts = [];
    var place = [provider && provider.city, provider && provider.state].filter(Boolean).join(', ');
    if (place) parts.push(place);

    var here = customerPoint();
    var coords = provider && provider.location && provider.location.coordinates;
    if (here && Array.isArray(coords) && coords.length >= 2) {
      var miles = milesBetween(here.lng, here.lat, coords[0], coords[1]);
      parts.push(distanceAway(miles));
    }
    return parts.join(' · ');
  }

  // Clearing goes through ProviderStateManager so the bar, the cart form and
  // this card all hear providerCodeRemoved and update together.
  function wireRemove(root) {
    var el = root.querySelector('[data-provider-card-remove]');
    if (!el || el.dataset.wired) return;
    el.dataset.wired = '1';
    el.addEventListener('click', function () {
      if (window.ProviderStateManager) window.ProviderStateManager.clearProvider();
    });
  }

  function render(state, name, provider, code) {
    currentCode = state === 'assigned' ? code || currentCode : null;
    roots().forEach(function (root) {
      root.dataset.state = state;
      root.dataset.code = currentCode || '';
      var nameEl = root.querySelector('[data-provider-pdp-name]');
      var metaEl = root.querySelector('[data-provider-pdp-meta]');
      var actionEl = root.querySelector('[data-provider-pdp-action]');

      if (state === 'assigned') {
        if (nameEl) nameEl.textContent = name || '';
        if (metaEl) metaEl.textContent = provider ? metaLine(provider) : '';
        if (actionEl) actionEl.textContent = 'Change provider';
      } else if (state === 'empty') {
        if (nameEl) nameEl.textContent = 'No provider selected';
        if (metaEl) metaEl.textContent = '';
        if (actionEl) actionEl.textContent = 'Select your provider';
      }
      wireRemove(root);
    });
  }

  // The modal and the locator page store only a name and a code, so the
  // card would have nothing to put on its second line. Rather than thread
  // the full record through every selection path, fetch the one record -
  // it is 567 bytes against the ~890KB of the unfiltered list.
  function hydrate(code, cached) {
    if (cached && cached.city && cached.location) return Promise.resolve(cached);
    if (!code) return Promise.resolve(cached);
    return fetch(PROVIDER_API + 'providers?providerCode=' + encodeURIComponent(code))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (matches) { return (Array.isArray(matches) && matches[0]) || cached; })
      .catch(function () { return cached; });
  }

  function showAssigned(code, name, provider) {
    render('assigned', name, provider, code);
    hydrate(code, provider).then(function (full) {
      if (full) render('assigned', name || full.name, full, code);
    });
  }

  // The header provider bar and this card must never disagree, so both
  // follow the same events the rest of the provider code already fires.
  document.addEventListener('providerCodeVerified', function (event) {
    var detail = event.detail || {};
    var provider = detail.data || null;
    showAssigned(detail.code, (provider && provider.name) || detail.code, provider);
  });

  document.addEventListener('providerCodeRemoved', function () {
    render('empty');
  });

  document.addEventListener('provider:auto-assign:done', function (event) {
    var provider = (event.detail || {}).provider || {};
    showAssigned(provider.providerCode, provider.name, provider);
  });

  document.addEventListener('provider:auto-assign:none', function () {
    // Auto-assign giving up is not the same as there being no provider. One may
    // already be on the cart from a referral link, an earlier visit or the
    // customer's own pick, and the cart is what the order is built from - so
    // only fall back to the prompt when there is genuinely nothing to show.
    // Not blocking add to cart either way.
    if (currentCode) return;
    render('empty');
  });

  // Fill in the second line for a provider that was already on the cart when
  // the page was served, and stop the placeholder spinning forever if
  // nothing ever resolves.
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-provider-pdp]');
    if (root && root.dataset.state === 'assigned' && root.dataset.code) {
      var nameEl = root.querySelector('[data-provider-pdp-name]');
      showAssigned(root.dataset.code, nameEl && nameEl.textContent.trim(), null);
    }
    setTimeout(function () {
      roots().forEach(function (el) {
        if (el.dataset.state === 'pending') render('empty');
      });
    }, 15000);
  });
})();
